import React, { useState, useEffect } from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import "./container.css";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}

const Container = (props) => {
  const [value, setValue] = React.useState(0);
  const [containerData, setContainerData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log({ props });
    setContainerData(props.containerData.data);
    setLoading(props.containerData.loading);
  }, [props]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Table = ({ element }) => {
    console.log({ element });
    return (
      <table>
        <tbody>
          <tr>
            <td>
              <label>Container Type</label>
              <p title={element.containerType}>{element.containerType}</p>
            </td>
            <td>
              <label>Seal Number</label>
              <p title={element.sealNumber}>{element.sealNumber}</p>
            </td>
          </tr>
          <tr>
            <td>
              <label>Piece Count</label>
              <p title={element.count}>{element.count}</p>
            </td>
            <td>
              <label>Commodity Description</label>
              <p>{element.commodityDescription}</p>
            </td>
          </tr>
          <tr>
            <td>
              <label>Weight1</label>
              <p title={element.grossWeight}>{element.grossWeight}kg</p>
            </td>
            <td>
              <label>Volume</label>
              <p>
                {element.volume}m<sup>3</sup>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <label>Packs</label>
              <p>{element.packs}</p>
            </td>
            <td>
              <label>Packs Type</label>
              <p>{element.packsType}</p>
            </td>
          </tr>
          <tr>
            <td>
              <label>TEU</label>
              <p>{element.teuCount}</p>
            </td>
            {/* <td>
              <label>Delivery Date</label>
              <p>
                {element.actualdeliverydate
                  ? moment(element.actualdeliverydate).format("MM/DD/YYYY")
                  : ""}
              </p>
            </td> */}
          </tr>
          <tr>
            <h6>Milestone</h6>
          </tr>
          <tr>
            <td>
              <label>Empty Release</label>
              <p>
                {element.emptyReleaseShipper
                  ? moment(element?.emptyReleaseShipper).format(
                      "MM/DD/YYYY HH:mm"
                    )
                  : ""}
              </p>
            </td>
            <td>
              <label>Wharf GateIn</label>
              <p>
                {element.wharfGateIn
                  ? moment(element?.wharfGateIn).format("MM/DD/YYYY HH:mm")
                  : ""}
              </p>
            </td>
          </tr>

          <tr>
            <td>
              <label>Container Loaded</label>
              <p>
                {element.containerLoaded
                  ? moment(element?.containerLoaded).format("MM/DD/YYYY HH:mm")
                  : ""}
              </p>
            </td>
            <td>
            <label>Discharge port gate out</label>
              <p>
                {element.gateOut
                  ? moment(element.gateOut).format(
                      "MM/DD/YYYY HH:mm"
                    )
                  : ""}
              </p>
             
            </td>
          </tr>

          <tr>
            <td>
            <label>Delivery Date</label>
              <p>
                {element.gateOut
                  ? moment(element?.gateOut).format(
                      "MM/DD/YYYY HH:mm"
                    )
                  : ""}
              </p>
             
            </td>
            <td>
              <label>Empty Returned</label>
              <p>
                {element.emptyContainerReturned
                  ? moment(element?.emptyContainerReturned).format(
                      "MM/DD/YYYY HH:mm"
                    )
                  : ""}
              </p>
            </td>
            {/* <td>
              <label>Delivery Date</label>
              <p>
                {element.actualdeliverydate
                  ? moment(element.actualdeliverydate).format("MM/DD/YYYY")
                  : ""}
              </p>
            </td> */}
          </tr>
        </tbody>
      </table>
    );
  };

  if (loading) {
    return (
      <div>
        <CircularProgress size="1.5rem" />
      </div>
    );
  }

  return (
    <div className="shipmentContainerComp">
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="on"
        className="shipmentContainerHeader"
      >
        {containerData.map((element) => {
          return (
            <Tab key={element.contanerNumber} label={element.contanerNumber} />
          );
        })}
      </Tabs>
      <div className="shipmentContainerBody">
        {containerData.map((element, index) => {
          return (
            <TabPanel key={index} value={value} index={index}>
              <Table element={element} />
            </TabPanel>
          );
        })}
      </div>
    </div>
  );
};

export default Container;
